import React, { useEffect, useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Grid,
  makeStyles,
} from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useHistory, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Layout from "../../../components/layout/Layout";
import Controls from "../../../components/controls/Controls";
import Notify from "../../../components/customHelpers/Notify";
import Loading from "../../../components/customHelpers/Loading";
import Order from "../../../actions/order";
import ProductDetails from "./orderProfiel";
import CompanyInfo from "./companyInfo";
import OrderReceipt from "./orderReceipt";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import Notification from "../../../components/customHelpers/Notification";
import { isAuth } from "../../../actions/auth";
import Assigntff from "./assignToUser";
import Popup from "../../../components/customHelpers/Popup";
import EditIcon from "@mui/icons-material/Edit";
import { getTimestamp } from "../../../utils/utils";

const noPrintStyle = {
  display: "none",
};

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(3),
    "& thead th": {
      fontWeight: 600,
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.main,
    },
    "& tbody td": {
      fontWeight: 300,
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
  },
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  listItem: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  primaryText: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
}));

const ShipmentDetailPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [isPercentDiscount, setIsPercentDiscount] = useState(true);
  const { viewOrder, updateOrderStatus, updateOrderProductsStatus } = Order();
  const [productData, setProductData] = useState(null);
  const [companyInfo, setCompany] = useState(null);
  const [event, setEvent] = useState(null);
  const [tempProductLists, setTempProductLists] = useState([]);
  const [isChecked, setIsChecked] = useState([]);

  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [productLists, setProductLists] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");

  const [isPrinting, setIsPrinting] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  let hasStoreKeeperPermission;
  useEffect(() => {
    getOrderData();
  }, [value]);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setCompany(JSON.parse(localStorage.getItem("user")));
    }
  }, []);

  const getOrderData = () => {
    viewOrder(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data) {
        console.log(value);
        setValues({ ...values, loading: false });
        setProductLists(data?.orders?.orderProducts);
        const products = data?.orders?.orderProducts || [];
        setTempProductLists(products);
        setIsChecked(new Array(products.length).fill(false)); // Initialize checked state

        setProductData(data?.orders);
        setPaid(data.orders?.paid);
      }
    });
  };
  useEffect(() => {
    if (productData) {
      setOrderStatus(productData.status);
    }
    hasStoreKeeperPermission =
      isAuth()?.staffRoles[0]?.role?.rolePermissions.some(
        (permission) => permission.action === "storeKeeper"
      );
  }, [productData, isAuth()]);
  const currencies = ["Ordered"];
  if (orderStatus !== "Pending") {
    currencies.push("Ready for Shipment");
  }
  currencies.push("Pending");
  if (orderStatus === "Shipped") {
    currencies.push("Shipped");
  }
  const handleStatusChange = (event) => {
    updateOrderStatus({ status: event.target.value }, value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        if(event.target.value === "Pending" || event.target.value === "Ordered"){
          history.push(`/print/${value}`);
        }
        setOrderStatus(event.target.value);
        NotifyMessage({
          message: "Order Status Successfully updated",
          type: "success",
        });
        getOrderData();
      }
    });
  };

  const [paid, setPaid] = useState("");
  const [unpaid, setUnpaid] = useState("");

  const handlePaidChange = (event) => {
    const newPaid = parseFloat(event.target.value) || 0;
    setPaid(newPaid);
    const remaining = calculateTotalPrice() - newPaid;
    setUnpaid(remaining < 0 ? 0 : remaining);
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    if (productLists?.length > 0) {
      productLists.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice) || 0;
      });
    }
    return totalPrice.toFixed(2);
  };

  const handlePrint = () => {
    setIsPrinting(true); // Set printing state to true
    setTimeout(() => {
      const input = document.getElementById("pdfContent");
      html2canvas(input, { scrollY: -window.scrollY }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const ratio = canvas.height / canvas.width;
        const width = pdfWidth - 20;
        let height = width * ratio;
        let position = 0;
        if (height > pdfHeight) {
          height = pdfHeight - 20;
          position = (pdfHeight - height) / 2;
        }
        pdf.addImage(imgData, "PNG", 10, position, width, height);
        let timestamp= getTimestamp()
        pdf.save(`<${productData?.customer.fullName}>_Sales-order_<${value}>_<${timestamp}>.pdf`);
        setIsPrinting(false);
      });
    }, 0);
  };
  const readyForShipment = (event) => {
    setEvent(event);
    setOpenPopupAssign(true);
  };
  const handleShippedChange = (index) => (event) => {
    const updatedChecked = [...isChecked];
    updatedChecked[index] = event.target.checked;
    setIsChecked(updatedChecked);
  };

  const saveShippingStatus = () => {
   setValues({ ...values, submitting: true });
    const itemsToUpdate = tempProductLists.filter(
      (_, index) => isChecked[index]
    );
    console.log(itemsToUpdate)
    updateOrderProductsStatus({ items: itemsToUpdate }, value).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else {
        NotifyMessage({ message: "Order Product status successfully updated", type: "success" });
        setIsChecked(new Array(tempProductLists.length).fill(false)); // Reset checked state
      }
      setValues({ ...values, submitting: false });
      getOrderData(); // Refresh the order data
    });
  };
  return (
    <Layout>
      <Typography variant="h6">
        <ArrowBackIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push("/shipment-order");
          }}
        />
        <span style={{ marginLeft: "6px" }}>Shipment Detail</span>
      </Typography>
      <Box display="flex" justifyContent="start" m={1} p={1}>
        <span style={{ marginTop: "10px" }}>
          <Controls.Button
            text="Print"
            variant="outlined"
            startIcon={<PrintIcon />}
            className="newButton"
            onClick={handlePrint}
          />
        </span>
      </Box>

      <Box display="flex" justifyContent="flex-end" m={1} p={1}>
        <FormGroup style={{ marginLeft: "12px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isPercentDiscount}
                onChange={(e) => setIsPercentDiscount(e.target.checked)}
              />
            }
            label="Print Bill From"
          />
        </FormGroup>
        <TextField
          id="outlined-select-currency"
          select
          disabled={isAuth()?.id !== productData?.assignTo}
          label="Select Status"
          sx={{ width: "15%" }}
          value={orderStatus}
          onChange={(event) => {
            const newStatus = event.target.value;
            if (newStatus === "Ready for Shipment") {
              readyForShipment(event);
            } else {
              handleStatusChange(event);
            }
          }}
        >
          {currencies.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <div id="pdfContent" className="card">
        <Box
          sx={{ marginTop: "15px" }}
          display="flex"
          justifyContent={isPercentDiscount ? "space-between" : "center"}
        >
          <Box>
            {productData && (
              <ProductDetails
                product={productData}
                getProductData={getOrderData}
                edit="false"
              />
            )}
          </Box>
          {isPercentDiscount && (
            <Box>
              {companyInfo && (
                <CompanyInfo
                  company={companyInfo?.organization}
                  getProductData={getOrderData}
                  edit="false"
                />
              )}
            </Box>
          )}

          <Box display="flex" justifyContent="flex-end">
            <Box>{productData && <OrderReceipt order={productData} />}</Box>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <TableContainer component={Paper}>
                <Table className={classes.table} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Product Name</TableCell>
                      <TableCell style={isPrinting ? noPrintStyle : {}}>
                        Store
                      </TableCell>
                      <TableCell>Sku</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Item Price</TableCell>
                      <TableCell>Discount</TableCell>
                      <TableCell>Total Price</TableCell>
                      <TableCell style={isPrinting ? noPrintStyle : {}}>
                        Date
                      </TableCell>
                      {(isAuth()?.staffRoles[0]?.role?.rolePermissions?.some(
                        (permission) =>
                          permission.action === "onlyMineShipment" ||
                          permission.action === "viewAllShipment"
                      ) ||
                        isAuth()?.role === "admin") && (
                        <TableCell>Shipped</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tempProductLists.map((row, index) => (
                      <TableRow key={row.productName}>
                        <TableCell>{row.productName}</TableCell>
                        <TableCell style={isPrinting ? noPrintStyle : {}}>
                          {row.store}
                        </TableCell>
                        <TableCell>{row.sku}</TableCell>
                        <TableCell>{row.quantity}</TableCell>
                        <TableCell>{row.price}</TableCell>
                        <TableCell>{row.discount}</TableCell>
                        <TableCell>{row.totalPrice}</TableCell>
                        <TableCell style={isPrinting ? noPrintStyle : {}}>
                          {new Date(row?.updatedAt).toLocaleDateString()}
                        </TableCell>
                        <>
                          {(isAuth()?.staffRoles[0]?.role?.rolePermissions?.some(
                            (permission) =>
                              permission.action === "onlyMineShipment" ||
                              permission.action === "viewAllShipment"
                          ) ||
                            isAuth()?.role === "admin") && (
                            <TableCell>
                              <Checkbox
                                checked={row.isShiped || isChecked[index]} // Show as checked if already shipped or checked
                                onChange={handleShippedChange(index)}
                                disabled={row.isShiped} // Disable if already shipped
                              />
                            </TableCell>
                          )}
                        </>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
        
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <TextareaAutosize
            aria-label="minimum height"
            minRows={7}
            placeholder="Remark"
            value={productData?.remark}
            style={{
              width: 400,
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              resize: "both",
            }}
          />
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
            p: 1,
            m: 1,
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          {calculateTotalPrice() && (
            <Box p={1}>
              <div
                style={{
                  marginRight: "35px",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}
              >
                Total Price: {calculateTotalPrice()}
              </div>
            </Box>
          )}
          <Box p={1}>
            <span style={{ marginRight: "10px" }}>Paid</span>
            <TextField disabled value={paid} onChange={handlePaidChange} />
          </Box>
          {calculateTotalPrice() > 0 && (
            <Box p={1}>
              <span style={{ marginRight: "10px" }}>Balance</span>
              <TextField
                disabled
                value={
                  unpaid > 0
                    ? unpaid
                    : calculateTotalPrice() - productData?.paid
                }
              />
            </Box>
          )}

          <Box p={1}>
            {(isAuth()?.staffRoles[0]?.role?.rolePermissions?.some(
              (permission) =>
                permission.action === "onlyMineShipment" ||
                permission.action === "viewAllShipment"
            ) ||
              isAuth()?.role === "admin") && (
              <Controls.Button
                text="Change Into Shippment"
                variant="contained"
                disabled={values.submitting}
                className="Button"
                onClick={saveShippingStatus}
              />
            )}
          </Box>
        </Box>
        </Box>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
      <Popup
        title="Assign User"
        openPopup={openPopupAssign}
        setOpenPopup={setOpenPopupAssign}
      >
        <Assigntff
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopupAssign}
          getAllOrders={getOrderData}
          handleStatusChange={handleStatusChange}
          id={value}
          event={event}
        />
      </Popup>
    </Layout>
  );
};

export default ShipmentDetailPage;
